import React from 'react';
import TextElement from './elements/TextElement';
import ImageElement from './elements/ImageElement';
import ShapeElement from './elements/ShapeElement';

export default function ElementRenderer({ element, scale = 1, messengerStyle = false, fontScaleFactor = 1 }) {
  if (!element?.type || !element.position || !element.size) {
    console.warn('Invalid element:', element);
    return null;
  }

  // Detailed logging for debugging
  if (messengerStyle) {
    console.log('%c ElementRenderer - MESSENGER STYLE', 'background: #4267B2; color: white; padding: 2px 5px;');
    console.log('Element Type:', element.type);
    if (element.type === 'text') {
      console.log('Text Content:', element.content?.substring(0, 30) + (element.content?.length > 30 ? '...' : ''));
    }
  }

  const commonProps = {
    position: element.position,
    size: element.size,
    style: element.style,
    scale,
    fontScaleFactor,
    messengerStyle: messengerStyle // Make sure this is explicitly passed
  };

  switch (element.type) {
    case 'text':
      return (
        <TextElement
          {...commonProps}
          content={element.content}
        />
      );
    case 'image':
      return (
        <ImageElement
          {...commonProps}
          src={element.src}
          hasBorder={element.hasBorder}
          borderColor={element.borderColor}
          borderWidth={element.borderWidth}
          borderStyle={element.borderStyle}
          borderRadius={element.borderRadius}
          borderOpacity={element.borderOpacity}
        />
      );
    case 'shape':
      return (
        <ShapeElement
          {...commonProps}
          shape={element.shape}
        />
      );
    default:
      console.warn(`Unknown element type: ${element.type}`);
      return null;
  }
}